import { render } from "./MmbsCardBack.vue?vue&type=template&id=18651b59&ts=true"
import script from "./MmbsCardBack.vue?vue&type=script&lang=ts"
export * from "./MmbsCardBack.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__